import React, { useState } from "react";
import filterimg from "../../assets/images/filter.svg";
import JobTabComponent from "../../components/Dashboard/JobTabComponent";
import FiltersPop from "components/Modals/FormPopup/FiltersPop";

const Myjobs = () => {
  const [show, setShow] = useState(false)
  const [data, setData] = useState('')
  const handleShow = () => {
    setShow(true);
  }
  const handleClose = () => {
    setShow(false)
  }

  return (
    <div className="container-box">
      <div className="">
        <div className="top-head d-flex flex-wrap justify-content-between align-items-center text-white px-5">
          <h2>My Jobs</h2>
          <div className="filterdiv" onClick={handleShow}>
            <img src={filterimg} alt="" className="cursor-pointer" />

          </div>
          <FiltersPop show={show} handleShow={handleShow} handleClose={handleClose} data={data} setData={setData} />
        </div>
      </div>
      <div className="my-job-tabs my-job-myjobs-tabs">
        <JobTabComponent data={data} setData={setData} />
      </div>
    </div>
  );
};

export default Myjobs;
